import React from "react";

/**
 * Animated waveform bars — pure CSS. Idle when not recording, pulses when active.
 */
export default function Waveform({ active = false, count = 24 }) {
  return (
    <div className="flex items-center justify-center h-10" aria-hidden="true">
      {Array.from({ length: count }).map((_, i) => {
        const delay = `${(i % 6) * 0.12}s`;
        const idleHeight = 6 + ((i * 7) % 14);
        return (
          <span
            key={`wave-bar-${i}`}
            className={`wave-bar ${active ? "wave-bar-recording" : ""}`}
            style={{
              height: active ? "28px" : `${idleHeight}px`,
              animationDelay: delay,
              opacity: active ? 1 : 0.35,
            }}
          />
        );
      })}
    </div>
  );
}
